<template>
  <v-container
    grid-list-xl
    fluid
    style="padding-top: 0;">
    <v-layout
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          :title="$t('common.search')"
          color="green"
          flat
          full-width
          class="bg-white"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md3>
                  <v-select
                    :items="bannerStatusList"
                    v-model="bannerStatusSelected"
                    :label="$t('evoucher.issuance.status')"
                  >
                    <template
                      slot="selection"
                      slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ $t(data.item.text) }}
                    </template>
                    <template
                      slot="item"
                      slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ $t(data.item.text) }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-btn
                style="margin-right: 0;"
                class="pull-right"
                color="success"
                @click="onSearch"
              >
                <span class="btn-label mr-3">
                  <i class="glyphicon glyphicon-search" />
                </span>
                <span style="text-transform: none;">{{
                  $t("common.search")
                }}</span>
              </v-btn>
            </v-container>
          </v-form>
        </material-card>
        <material-card
          :title="$t('portal.banner.sliderList')"
          color="green"
          flat
          full-width
        >
          <template>
            <v-btn
              color="success"
              dark
              style="float: right;"
              @click="onShowModalAddBannerSlider(null)"
            >
              {{ $t('common.add') }}
            </v-btn>
          </template>
          <v-data-table
            :no-data-text="$t('common.noDataAvailable')"
            :headers="advertisementHeader"
            :items="advertisementInfoList"
            :single-select="true"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text--darken-3 font-medium"
                v-text="$t(header.text)"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.stt }}</td>
              <td>
                <img
                  :src="item.imageUrl ? item.imageUrl : noImg"
                  width="60"
                  height="40"
                  style="border: 2px solid #fff;">
              </td>
              <td>{{ item.title }}</td>
              <td><a
                :href="item.link"
                target="_blank">{{ item.link }}</a></td>
              <td style="max-width: 250px;">{{ item.description }}</td>
              <td style="max-width: 250px;">
                <span :style="`padding: 5px; background-color: ${item.status == bannerStatus.PREPARE ? '#ffa21a' : (item.status == bannerStatus.ACTIVE ? '#4caf50' : '#f44336')}; color: #fff; border-radius: 5px;`">{{ $t(getStatus(item.status)) }}</span>
              </td>
              <td class="text-xs-center">
                <v-menu
                  v-model="item.selectedButton"
                  offset-y
                  transition="slide-y-transition"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="indigo"
                      dark
                      v-on="on"
                    >
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <!-- Update supplier -->
                    <v-tooltip
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          color="warning"
                          style="color: #ffffff;"
                          v-on="on"
                          @click="(item.status == bannerStatus.PREPARE || item.status == bannerStatus.CLOSE) ? onShowModalPublicBanner(item) : onShowModalInactiveBanner(item)">
                          <v-icon
                            v-if="(item.status == bannerStatus.PREPARE || item.status == bannerStatus.CLOSE)"
                            dark>mdi-check-underline</v-icon>
                          <v-icon
                            v-else-if="item.status != bannerStatus.PREPARE && item.status != bannerStatus.CLOSE"
                            dark>mdi-close-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ (item.status == bannerStatus.PREPARE || item.status == bannerStatus.CLOSE) ? $t('bannerInfo.status.public') : $t('bannerInfo.status.inactive') }}</span>
                    </v-tooltip>
                    <!-- Update supplier -->
                    <v-tooltip
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          color="primary"
                          style="color: #ffffff;"
                          v-on="on"
                          @click="onShowModalAddBannerSlider(item.id)">
                          <v-icon dark>mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('common.update') }}</span>
                    </v-tooltip>
                    <!-- Delete supplier -->
                    <v-tooltip
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          color="red"
                          style="color: #ffffff;"
                          v-on="on"
                          @click="onShowModalDeleteBannerSlider(item.id)">
                          <v-icon dark>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('common.delete') }}</span>
                    </v-tooltip>
                  </v-card>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <pagination
      :total="advertisementPaginate.totalPage"
      :current-page="advertisementPaginate.currentPage"
      :row-per-page="advertisementPaginate.rowPerPage"
      @onPageChange="onPageChange"
    />
    <addBannerSliderModal
      ref="modalBannerSlider"
      @addBannerSliderSuccess="onAddBannerSliderSuccess"/>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"/>
    <!-- <userDetailModal ref="userDetailModal" /> -->
    <loadingBar :is-loading="isLoading" />
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AddBannerSliderModal from '../ModalAddBanner.vue'
import ToastType from 'enum/toastType'
import bannerType from 'enum/bannerType'
import bannerStatus from 'enum/bannerStatus'
import stringUtils from 'utils/stringUtils'
import PortalBannerType from 'enum/portalBannerType'
import functionUtils from 'utils/functionUtils'
export default {
  components: {
    AddBannerSliderModal
  },
  data: () => ({
    advertisementHeader: [
      {
        sortable: false,
        text: 'common.nonumber',
        value: 'stt'
      },
      {
        sortable: false,
        text: 'common.image',
        value: 'imageUrl'
      },
      {
        sortable: false,
        text: 'bannerInfo.title',
        value: 'title'
      },
      {
        sortable: false,
        text: 'portal.banner.link',
        value: 'link'
      },
      {
        sortable: false,
        text: 'bannerInfo.description',
        value: 'description'
      },
      {
        sortable: false,
        text: 'evoucher.issuance.status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'common.actions',
        value: 'actions',
        align: 'center'
      }
    ],
    advertisementInfoList: [],
    advertisementPaginate: {
      totalPage: 1,
      currentPage: 1,
      rowPerPage: 1
    },
    userSearch: {
      userName: null,
      userFullName: null,
      userPhone: null,
      userGender: null,
      userEmail: null
    },
    isLoading: false,
    noImg: require('@/assets/noimage.png'),
    bannerTypeList: [{ text: '---', value: null }, ...stringUtils.BannerTypeList],
    bannerTypeSelected: null,
    bannerStatusList: [{ text: '---', value: null }, ...stringUtils.BannerStatusList],
    bannerStatusSelected: null,
    bannerStatus: {
      PREPARE: bannerStatus.PREPARE,
      ACTIVE: bannerStatus.PUBLIC,
      CLOSE: bannerStatus.CLOSE
    },
  }),
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR',
      'GET_CURRENT_ACCOUNT',
      'BANNER_SLIDER_LIST_DATA'
    ])
  },
  watch: {
    BANNER_SLIDER_LIST_DATA () {
      let res = this.BANNER_SLIDER_LIST_DATA
      // Handle paginate
      this.advertisementPaginate.currentPage = res.paginate.currentPage
      this.advertisementPaginate.totalPage = res.paginate.totalPage
      this.advertisementPaginate.rowPerPage = res.paginate.perPage / 2
      // Handle data
      let data = res.results
      this.advertisementInfoList = []
      for (let i = 0, size = data.length; i < size; i++) {
        let advertisementInfoObj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          id: data[i].id,
          title: data[i].title,
          description: data[i].description,
          imageUrl: data[i].image_url,
          selectedButton: false,
          status: data[i].status,
          link: data[i].link
        }
        this.advertisementInfoList.push(advertisementInfoObj)
      }
      this.isLoading = false
    }
  },
  created () {
    this.getBannerSliderList()
  },
  methods: {
    /**
     * To do In active banner
     */
    onInactiveBanner: function (bannerId) {
      let filter = {
        id: bannerId
      }
      this.TO_DO_INACTIVE_BANNER_PORTAL(filter).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getBannerSliderList()
        }.bind(this)
      )
    },
    /**
     * Show modal Inactive banner
     */
    onShowModalInactiveBanner: function (item) {
      this.$message.confirm({
        message: this.$t('bannerInfo.message.prepare'),
        onConfirm: () => {
          this.onInactiveBanner(item.id)
        }
      });
    },
    /**
     * Show modal Public banner
     */
    onShowModalPublicBanner: function (item) {
      this.$message.confirm({
        message: this.$t('bannerInfo.message.active'),
        onConfirm: () => {
          this.onPublicBanner(item.id)
        }
      });
    },
    /**
     * To do Public banner
     */
    onPublicBanner: function (bannerId) {
      let filter = {
        id: bannerId
      }
      this.PUBLIC_BANNER_PORTAL(filter).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getBannerSliderList()
        }.bind(this)
      )
    },
    /**
    * Type
    */
    getType: function (type) {
      if (bannerType.SMALL === type) {
        return 'bannerInfo.type.small'
      } else if (bannerType.LARGE === type) {
        return 'bannerInfo.type.large'
      } else if (bannerType.POPUP === type) {
        return 'bannerInfo.type.popupLearning'
      } else {
        return ''
      }
    },
    /**
     * Get banner status
     */
    getStatus: function (status) {
      if (status === bannerStatus.PREPARE) {
        return 'bannerInfo.status.prepare'
      } else if (status === bannerStatus.PUBLIC) {
        return 'bannerInfo.status.public'
      } else if (status === bannerStatus.CLOSE) {
        return 'bannerInfo.status.close'
      } else {
        return ''
      }
    },
    /**
     * Add advertisement success
     */
    onAddBannerSliderSuccess: function () {
      this.getBannerSliderList()
    },
    /**
     * Delete advertisement
     */
    onDeleteBannerSlider: function (bannerId) {
      this.DELETE_BANNER_SLIDER({ id: bannerId }).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getBannerSliderList()
        }.bind(this)
      ).catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    /**
     * Search
     */
    onSearch: function () {
      this.getBannerSliderList()
    },
    /**
     * Show modal add user
     */
    onShowModalAddBannerSlider: function (bannerSliderId) {
      this.$refs.modalBannerSlider.onShowModal(bannerSliderId, PortalBannerType.SLIDER)
    },
    /**
     * Show modal delete user
     */
    onShowModalDeleteBannerSlider: function (bannerSliderId) {
      this.$confirmMatch({
        message: 'Bạn có chắc muốn xoá banner slider này?',
        matchText: 'DELETE',
        onConfirm: () => {
          this.onDeleteBannerSlider(bannerSliderId)
        }
      });
    },
    /**
     * Get advertisement list
     */
    getBannerSliderList: function () {
      let filter = {
        params: {
          type: PortalBannerType.SLIDER,
          status: this.bannerStatusSelected,
          page: this.advertisementPaginate.currentPage
        }
      }
      this.isLoading = true
      this.GET_LIST_BANNER_SLIDER(filter)
    },
    /**
     * Page change
     */
    onPageChange: function (page) {
      this.advertisementPaginate.currentPage = page
      this.getBannerSliderList()
    },
    ...mapActions([
      'GET_LIST_BANNER_SLIDER',
      'ON_SHOW_TOAST',
      'DELETE_BANNER_SLIDER',
      'PUBLIC_BANNER_PORTAL',
      'TO_DO_INACTIVE_BANNER_PORTAL'
    ])
  }
}
</script>
<style lang="scss" scoped>
</style>
